import { render, staticRenderFns } from "./me.vue?vue&type=template&id=38d4a112&scoped=true&"
import script from "./me.vue?vue&type=script&lang=js&"
export * from "./me.vue?vue&type=script&lang=js&"
import style0 from "./me.vue?vue&type=style&index=0&id=38d4a112&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d4a112",
  null
  
)

export default component.exports